import { render } from "./GifGallery.vue?vue&type=template&id=65b528dd&scoped=true"
import script from "./GifGallery.vue?vue&type=script&lang=js"
export * from "./GifGallery.vue?vue&type=script&lang=js"

import "./GifGallery.vue?vue&type=style&index=0&id=65b528dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b528dd"]])

export default __exports__